export default __webpack_public_path__ + "img/Image-DevOps-Pages-2.0446adce.jpg";